import { collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { jwtDecode } from 'jwt-decode'; // Correct import
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/navbar8';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'; // Firebase Storage imports
import { db, storage } from '../firebase';
import './Signup.css';


const Update = () => {
  const [name, setName] = useState({ firstName: '', lastName: '' });
  const [description, setDescription] = useState('');
  const [domains, setDomains] = useState([]);
  const [newDomain, setNewDomain] = useState('');
  const [city, setCity] = useState('');
  const [pincode, setPincode] = useState('');
  const [gender, setGender] = useState('');
  const [instagram, setInstagram] = useState('');
  const [youtube, setYoutube] = useState('');
  const [linkedin, setLinkedin] = useState('');
  const [profileimage, setProfileimage] = useState('');
  const[image, setImage] = useState(null);
  const [userwebsite, setUserwebsite] = useState('');
  const [profession, setProfession] = useState('');
  const [fee, setFee] = useState('');
  const navigate = useNavigate();
  const { userId } = useParams(); // Get userId from the URL params
  const [imagePreview, setImagePreview] = useState(null); // State for image preview


  // Fetch existing profile data
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        //console.log(decodedToken);

        // Check token expiration
        const isExpired = Date.now() >= decodedToken.exp * 1000;
        if (isExpired) {
          localStorage.removeItem('token');
          navigate('/Login'); // Redirect to Login if token is expired
          return;
        }

        // Query the Firestore database for the user profile using userId
        const profileQuery = query(collection(db, 'Mentors'), where('userId', '==', userId));
        const querySnapshot = await getDocs(profileQuery);

        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            const profileData = doc.data();
            //console.log("Profile:", profileData);

            // Set profile data into the state
            setName({
              firstName: profileData.name.split(' ')[0],
              lastName: profileData.name.split(' ')[1] || ''
            });
            setDescription(profileData.description || "");
            setDomains(profileData.domains || []);
            setCity(profileData.city || "");
            setPincode(profileData.pincode || "");
            setGender(profileData.gender || "");
            setInstagram(profileData.instagram || "");
            setYoutube(profileData.youtube || "");
            setLinkedin(profileData.linkedin || "");
            setProfileimage(profileData.profileimage||"");
            setUserwebsite(profileData.userWebsite || "");
            setProfession(profileData.profession||"");
            setFee(profileData.fee||"");
            setImagePreview(profileData.profileimage); // Set initial image preview

        });
        } else {
          //console.log("No such document!");
        }
      } catch (error) {
        console.error("Error getting document:", error);
        alert(error.message);
      }
    };

    fetchProfile();
  }, [navigate, userId]); // userId is a URL parameter, so include it as a dependency


  // Add domain
  const addDomain = () => {
    if (newDomain.trim() && !domains.includes(newDomain)) {
      setDomains([...domains, newDomain]);
      setNewDomain('');
    }
  };

  // Remove domain
  const removeDomain = (domain) => {
    setDomains(domains.filter((d) => d !== domain));
  };
  const handleUpload = async (file) => {
    if (file) {
      const storageRef = ref(storage, `profileimages/${file.name}`);
      try {
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        setProfileimage(downloadURL); // Save the download URL to the state
        console.log('Profile image successfully uploaded and URL saved.');
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  };

    
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      if (image) {
        await handleUpload(image); // Upload image and update profile image URL
      }       
        // Query the Firestore database to get the profile document using userId
      const profileQuery = query(collection(db, 'Mentors'), where('userId', '==', userId));
      const querySnapshot = await getDocs(profileQuery);

      if (!querySnapshot.empty) {
        querySnapshot.forEach(async (docSnapshot) => {
          const profileDoc = doc(db, 'Mentors', userId); // Correctly reference the document

          // Update the document with the new profile data
          await updateDoc(profileDoc, {
            name: `${name.firstName} ${name.lastName}`,
            description: description,
            domains: domains,
            city: city,
            pincode: pincode,
            gender: gender,
            instagram: instagram,
            youtube: youtube,
            linkedin: linkedin,
            profileImage: profileimage,
            userwebsite: userwebsite,
            profession: profession,
            fee: fee

          });

          alert("Profile updated successfully!");
          navigate(`/Mentors/${userId}`); // Redirect to the profile page after update
        });
      } else {
        //console.log("No such document to update!");
        alert("No such document to update!");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert(error.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>FlarEdge | Update Profile</title>
        <meta name="description" content="Update your profile information." />
      </Helmet>
      <Navbar />
      <section className="h-100 bg-dark">
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100" >
            <div className="col">
              <div className="card card-registration my-4">
                <div className="card-body p-md-5  row  text-black">
              
                  <div className="col-xl-12">
                  <h2 className="mb-3 text-start">Update your profile</h2>
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="First Name"
                        value={name.firstName}
                        onChange={(e) => setName({ ...name, firstName: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6 mb-5">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Last Name"
                        value={name.lastName}
                        onChange={(e) => setName({ ...name, lastName: e.target.value })}
                      />
                    </div>
                  </div>

                  {/* Gender Selection */}
                  <div className="d-md-flex justify-content-start align-items-center mb-5 py-2">
                    <h6 className="mb-0 me-4 pe-2 text-start">Gender: </h6>
                    <div className="form-check form-check-inline mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        value="Female"
                        checked={gender === "Female"}
                        onChange={() => setGender("Female")}
                      />
                      <label className="form-check-label">Female</label>
                    </div>
                    <div className="form-check form-check-inline mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        value="Male"
                        checked={gender === "Male"}
                        onChange={() => setGender("Male")}
                      />
                      <label className="form-check-label">Male</label>
                    </div>
                    <div className="form-check form-check-inline mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        value="Others"
                        checked={gender === "Others"}
                        onChange={() => setGender("Others")}
                      />
                      <label className="form-check-label">Others</label>
                    </div>
                  </div>

                  {/* City and Pincode */}
                  <input
                    type="text"
                    className="form-control form-control-lg mb-3"
                    placeholder="City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                  <input
                    type="text"
                    className="form-control form-control-lg mb-3"
                    placeholder="Pincode"
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                  <input
                    type="text"
                    className="form-control form-control-lg mb-3"
                    placeholder="profession"
                    value={profession}
                    onChange={(e) => setProfession(e.target.value)}
                  />
                  

                  {/* Description */}
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>

                 {/* Domain Input */}
                    <div className="input-group mb-3 mt-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Add Domain"
                        value={newDomain}
                        onChange={(e) => setNewDomain(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && addDomain()}
                    />
                    <button className="btn btn-outline-secondary " type="submit" onClick={addDomain}>
                        Add
                    </button>
                    </div>
                    <ul className="list-group mb-1">
                    {domains.map((domain) => (
                        <li key={domain} className="list-group-item d-flex justify-content-between align-items-center">
                        {domain}
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => removeDomain(domain)}>
                            x
                        </button>
                        </li>
                    ))}
                    </ul>


                  {/* Social Links */}
                  <input
                    type="url"
                    className="form-control form-control-lg mb-3 mt-3"
                    placeholder="Instagram"
                    value={instagram}
                    onChange={(e) => setInstagram(e.target.value)}
                  />
                  <input
                    type="url"
                    className="form-control form-control-lg mb-3"
                    placeholder="YouTube"
                    value={youtube}
                    onChange={(e) => setYoutube(e.target.value)}
                  />
                  <input
                    type='url'
                    className="form-control form-control-lg mb-3"
                    placeholder="LinkedIn"
                    value={linkedin}
                    onChange={(e) => setLinkedin(e.target.value)}
                  />
                  <input 
                  type='url'
                  className="form-control form-control-lg mb-3"
                  placeholder="own a website?"
                  value={userwebsite}
                  onChange={(e) =>setUserwebsite(e.target.value)}

                  
                  /><label htmlFor='profile-image'>Profile Image:&nbsp;&nbsp;&nbsp;</label>
                  <input 
                    type="file" 
                    name="profile-image" 
                    placeholder={profileimage} 
                    onChange={async(e) => {   const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                          setImagePreview(e.target.result); // Set the image data URL for preview
                        };
                        reader.readAsDataURL(file);
                        setImage(file); // Set the actual file object here

                      }
;                      
                    }}
                  />
                          {imagePreview && <img src={imagePreview} alt="Profile preview" style={{ width: '100px', height: 'auto' }} />}

                  
                  <input
                    type="text"
                    className="form-control form-control-lg mb-3 mt-3"
                    placeholder="fee"
                    value={fee}
                    onChange={(e) => setFee(e.target.value)}
                  />
                  <button type="button" onClick={handleSubmit}  className="btn btn-dark btn-lg btn-block">Update Profile</button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Update;
